import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from '@core/components/toasts/toasts.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionPlanTypeService } from 'services/corporate/action-plan/action-plan-type.service';
import { ActionPlanTypeModel } from 'services/models/corporate/action-plan/action-plan-type.model';

@Component({
  selector: 'app-action-plan-type-manage-drawer',
  templateUrl: './action-plan-type-manage-drawer.component.html',
  styleUrls: ['./action-plan-type-manage-drawer.component.scss'],
})
export class ActionPlanTypeManageDrawerComponent implements OnInit {
  @Input() item?: ActionPlanTypeModel;
  @Input() source: string;

  public form: FormGroup;
  public isSubmitting: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _toasterService: ToastService,
    private _modalActiveService: NgbActiveModal,
    private _service: ActionPlanTypeService
  ) {}

  ngOnInit(): void {
    this._createForm();
  }

  public handleClose() {
    this._modalActiveService.close();
  }

  public async handleSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();

      return;
    }

    try {
      this.isSubmitting = true;

      const payload = this.item?.id ? { id: this.item?.id, ...this.form.value } : this.form.value;

      await this._service.createOrUpdate(payload).toPromise();

      this._toasterService.showSuccess('Tipo de ação cadastrada com sucesso');

      this._modalActiveService.close({ onRefetch: true });
    } catch (error) {
      this._toasterService.showError('Não foi possível cadastrar o tipo de ação');

      this.isSubmitting = false;
    } finally {
      this.isSubmitting = false;
    }
  }

  private _createForm() {
    this.form = this._formBuilder.group({
      title: [this.item?.title ?? '', Validators.required],
      source: [this.source],
    });
  }

  public get drawerTitle(): string {
    return this?.item ? 'Editar tipo' : 'Novo tipo';
  }
}
